var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 13.3334V15.6667C13.3332 16.6002 13.3332 17.0669 13.1515 17.4234C12.9917 17.737 12.7368 17.992 12.4232 18.1518C12.0666 18.3334 11.5999 18.3334 10.6665 18.3334H4.33317C3.39975 18.3334 2.93304 18.3334 2.57652 18.1518C2.26292 17.992 2.00795 17.737 1.84816 17.4234C1.6665 17.0669 1.6665 16.6002 1.6665 15.6667V9.33341C1.6665 8.39999 1.6665 7.93328 1.84816 7.57676C2.00795 7.26316 2.26292 7.00819 2.57652 6.8484C2.93304 6.66675 3.39975 6.66675 4.33317 6.66675H6.6665M9.33317 13.3334H15.6665C16.5999 13.3334 17.0666 13.3334 17.4232 13.1518C17.7368 12.992 17.9917 12.737 18.1515 12.4234C18.3332 12.0669 18.3332 11.6002 18.3332 10.6667V4.33341C18.3332 3.39999 18.3332 2.93328 18.1515 2.57676C17.9917 2.26316 17.7368 2.00819 17.4232 1.8484C17.0666 1.66675 16.5999 1.66675 15.6665 1.66675H9.33317C8.39975 1.66675 7.93304 1.66675 7.57652 1.8484C7.26292 2.00819 7.00795 2.26316 6.84816 2.57676C6.6665 2.93328 6.6665 3.39999 6.6665 4.33341V10.6667C6.6665 11.6002 6.6665 12.0669 6.84816 12.4234C7.00795 12.737 7.26292 12.992 7.57652 13.1518C7.93304 13.3334 8.39975 13.3334 9.33317 13.3334Z",
    stroke: "#475467",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.dd7a4bd7c4bb9143373c948f2958b4e4.svg";
export { ForwardRef as ReactComponent };